<template>
  <div>
    <div class="zn-template-head">
      <span class="zn-template-title">新建公司</span>
      <span class="zn-text-grey">每个问题中 “ ” 里的的话术可以直接照着念，询问客户信息</span>
    </div>
    <div class="zn-template-content" ref="tplContent">
      <div v-loading="submiting"
        element-loading-text="努力解析中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)">
        <div class="zn-content-item-inline" :class="{ inputError: inputError.公司名称 }">
          <div style="width:70px">
            <span class="zn-text-grey"><span style="color:#f00">*</span>公司名称：</span>
          </div>
          <div style="flex:1">
            <el-select
              v-model="formData.公司名称"
              size="mini"
              placeholder="公司名称"
              filterable
              remote
              default-first-option
              :remote-method="newCheckCompanyName"
              @change="checkRequiredField('公司名称')"
              style="width:100%"
            >
              <el-option v-for="item in fuzzySearchOptionHasCreated" :key="item.tianyanchaId" :value="item.公司" class="new-add-company">
                <div style="display: flex;justify-content: space-between;">
                  <span>{{ item.公司 }}（已存在点击可跳转详情）</span>
                </div>
              </el-option>
              <p style="text-align: center;color: #bababa;margin-top: 4px;font-size: 14px;">以下公司来自天眼查数据，点击即刻创建</p>
              <el-option v-for="item in fuzzySearchOptionHasNotCreated" :key="item.tianyanchaId" :value="item.公司" class="new-add-company">
                <div style="display: flex;justify-content: space-between;">
                  <span>{{ item.公司 }}</span>
                </div>
              </el-option>
            </el-select>
            <p v-if="inputError.公司名称&&hasCreateCompany">
              <span style="color:#f00">该公司已存在</span>
              <span class="a-link" @click.stop="openCompany(hasCreateCompany._id)">点击跳转公司详情</span>
            </p>
          </div>
        </div>
        <div class="zn-content-item-inline" :class="{ inputError: inputError.简称 }">
          <div style="width:70px">
            <span class="zn-text-grey"><span style="color:#f00">*</span>简称：</span>
          </div>
          <div style="flex:1">
            <el-input
              v-model="formData.简称"
              size="mini"
              placeholder="简称"
              @blur="checkRequiredField('简称')"
              @change="checkRequiredField('简称')"
            ></el-input>
            <div v-if="inputError.简称 && hasCreateCompanyShortName" style="color:#f00">简称与现有公司简称重复，请修改简称。<br>注：如果目前填写正确，可继续创建，简称后面会加上（临时），不影响使用，请通知管理员，数据团队后续会统一处理</div>
          </div>
        </div>

        <div class="zn-content-item" v-for="(field, k) in fields" :key="k">
          <div class="zn-text-grey">{{ field.label }}：</div>
          <el-input
            type="textarea"
            :rows="3"
            :placeholder="field.placeholder"
            v-model="formData[field.value]">
          </el-input>
        </div>
      </div>
    </div>
    <div class="zn-template-submit" @click="submit">完成填写</div>
  </div>
</template>
<script>
export default {
  props: {
    componentName: String,
  },
  data() {
    return {
      formData: {},
      companyNameOptions: [],
      fuzzySearchOptions:[],
      fuzzySearchOptionHasCreated:[],
      fuzzySearchOptionHasNotCreated:[],
      inputError: {
        公司名称: false,
        简称: false,
      },
      hasCreateCompany: null,
      fields: [
        {
          label: '一句话介绍', value: '一句话简介',
          placeholder: '最能体现该家公司价值的一句话'
        },
        {
          label: '公司介绍', value: '公司介绍',
          placeholder: '详情介绍',
        },
        {
          label: '公司亮点', value: '公司亮点.content',
          placeholder: '“ 猎头是向候选人传达公司形象的核心渠道，您觉得咱们公司有哪些核心优势需要我们来帮您传达 ”',
        },
        {
          label: '公司劣势', value: '公司劣势.content',
          placeholder: '“ 近期我们有哪些看重候选人没谈成的情况，大概原因是什么？比如薪酬职级是否需要我们在前期做预期管理，或者是一些不好的市场传闻我们可以后期在市场上做一些辟谣 ”',
        },
        {
          label: '业务特点/风格/资源来源', value: '业务特点/风格/资源来源.content',
          placeholder: '市场化；长期主义；正直等',
        },
        {
          label: '用人偏好', value: '人员整体情况',
          placeholder: '“ 我们对人才上面有什么特别的要求，比如说年龄，性别，学历背景，或者说过往比较倾向于哪些平台的人，然后软性上领导会有哪些偏好？ ”',
        },
        {
          label: '公司薪酬概况', value: '薪酬/职级/奖金机制',
          placeholder: '” 我们找这个岗位大概的固薪范围或者机制上大概是？ ”',
        },
        {
          label: '特殊要求', value: '特殊要求寻访',
          placeholder: '“ 咱们对推荐报告及推荐流程有什么特殊的要求吗，比如要上传到特定系统或者推荐报告使用特定模版？ ”',
        },
        {
          label: '奖金递延及补偿机制', value: 'companyMoneyTable.content.递延机制',
          placeholder: '',
        },
      ],
      submiting: false,
    }
  },
  watch: {
    formData: {
      // 缓存到local
      handler: function (newVal) {
        localStorage.setItem(this.componentName, JSON.stringify(newVal))
      },
      deep: true
    }
  },
  methods: {
    async newCheckCompanyName(query) {
      const res = await app.service('company').getCompanyOptionByKeyword(query)
      if (res.status === 'success') {
        const { hasCreated, hasNotCreated } = res.data
        this.fuzzySearchOptionHasCreated = hasCreated
        this.fuzzySearchOptionHasNotCreated = hasNotCreated
        this.fuzzySearchOptions = [...hasCreated,...hasNotCreated]
      } else this.$message.error(res.msg)
    },
    checkRequiredField(field) {
      const value = this.formData[field]
      if (field === '公司名称') {
        const choose = this.fuzzySearchOptions.find(val => val.公司 === value)
        if(choose&&!choose.companyId){
          this.formData.tianyanchaId = choose.tianyanchaId
          this.getTianyanchaDetail(choose.tianyanchaId)
          this.getTianyanchaIntro(choose.tianyanchaId)
        }else if(choose&&choose.companyId){
          this.openCompany(choose&&choose.companyId)
        }
        this.checkCompanyName(field)
      } else if (field === '简称') {
        this.checkCompanyName(field)
      } else {
        this.inputError[field] = !this.formData[field]
      }
    },
    openCompany(cid){
      window.open(`${window.origin}/#/company/${cid}`)
    },
    async getTianyanchaDetail(tianyanchaId){
      const res = await app.service('company').getTianyanchaDetail(tianyanchaId)
      if (res.status === 'success') {
        const detail = res.data
        if(detail.alias){
          this.$set(this.formData,'简称',detail.alias)
          this.checkRequiredField('简称')
        }
      }
    },
    async getTianyanchaIntro(tianyanchaId){
      const res = await app.service('company').getTianyanchaIntro(tianyanchaId)
      if (res.status === 'success') {
        const intro = res.data
        if(intro) this.$set(this.formData,'公司介绍',intro)
      }
    },
    async checkCompanyName(field) {
      if(field==='简称') {
        this.hasCreateCompanyShortName = null
        if (!this.formData.公司名称) this.inputError.公司名称 = true
      }
      else this.hasCreateCompany = null
      const name = this.formData[field]
      if (!name) return (this.inputError[field] = true)
      const res = await app.service('company').checkHasCompany(name)
      if (res.status === 'success') {
        this.inputError[field] = !!res.companyId
        if(field==='简称') {
          this.hasCreateCompanyShortName = { _id: res.companyId, name: res.companyName,type:field }
        } else {
          this.hasCreateCompany = { _id: res.companyId, name: res.companyName,type:field }
        }
      } else this.$message.error(res.msg)
    },
    checkAllRequiredField(){
      for (const field in this.inputError) {
        if (!this.formData[field]) {
          this.inputError[field] = true
        }
      }
    },
    getInputError(){
      return this.inputError
    },

    async submit() {
      // console.log(this.formData)
      if (this.submiting) return this.$message('正在解析中，请稍候')
      this.checkAllRequiredField()
      if (!this.formData.公司名称) return this.$message('请填写公司名称')
      if (!this.formData.简称) return this.$message('请填写简称')
      if (this.inputError.公司名称) return this.$message('该公司已存在')
      this.submiting = true
      this.formData.时间 = Date.parse(new Date())
      const company = {}
      Object.keys(this.formData).forEach(k=>{
        const arr = k.split('.')
        if (arr.length == 1) {
          company[k] = this.formData[k]
        } else if (arr.length == 2) {
          company[arr[0]] = {}
          company[arr[0]][arr[1]] = this.formData[k]
        } else if (arr.length == 3) {
          company[arr[0]] = {}
          company[arr[0]][arr[1]] = {}
          company[arr[0]][arr[1]][arr[2]] = this.formData[k]
        }
      })
      const res = await app.service('company').quickCreateCompany({
        company,
      })
      if (res.status === 200 || res.status === 'success') {
        this.$emit('closeTpl', {msg: '小阿已为您解析并新建公司', other: {msgType:'new', cid: res.data._id, 简称: res.data.简称}})
      }
      localStorage.removeItem(this.componentName)
      this.submiting = false
    },
    initData(defaultForm) {
      this.formData = defaultForm || {}
    }
  }
}
</script>
<style>
  .inputError .el-input .el-input__inner {
    border-color: #f13000;
  }
</style>
